// extracted by mini-css-extract-plugin
export var addButton = "_cf-0";
export var border = "_cf-8";
export var check = "_cf-h";
export var danger = "_cf-6";
export var dropdownContainer = "_cf-1";
export var editModalBody = "_cf-j";
export var footerContainer = "_cf-i";
export var fullWidth = "_cf-a";
export var hide = "_cf-9";
export var icon = "_cf-3";
export var input = "_cf-7";
export var inputFlex = "_cf-b";
export var inputWrapper = "_cf-c";
export var manualFocus = "_cf-5";
export var optionButton = "_cf-4";
export var pillWrapper = "_cf-e";
export var pointer = "_cf-2";
export var showOverflow = "_cf-f";
export var tagsFlex = "_cf-d";
export var xButton = "_cf-g";